import React, { useState, useEffect } from 'react';
import HeaderWithIcon from '../../components/common/HeaderWithIcon';
import Filters from '../../components/common/Filters';
import Calendar from '../../components/common/Calendar';
import { ChevronUp, ChevronDown } from 'lucide-react';
// import { Button } from "flowbite-react";

import Button from '../../components/ui/Button';
import LogCard from './LogCard';

import { logsApi } from '../../api/logs';
import { useAuth } from '../../context/AuthContext';
import { Pagination } from 'flowbite-react';

const logFilter = [
  'ALL',
  'DEPOSIT',
  'WITHDRAW',
  'WALLET',
  'COMMISSION',
  'COMMISSION TO WALLET',
  'LOAD REQUEST',
  'WIN',
  'FLOAT',
];
const logList = [
  'EARNED',
  'WITHDRAW',
  'WALLET',
  'COMMISSION',
  "COMMISSION TO WALLET'",
  'LOAD REQUEST',
  'WIN',
  'FLOAT',
];

export default function Logs() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const { tokens } = useAuth();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState('');

  useEffect(() => {
    if (selectedFilter === 'ALL') {
      setSelectedFilter('');
    }
    const fetchLogs = async () => {
      try {
        const response = await logsApi.getLogs(
          tokens.access.token,
          currentPage,
          10,
          selectedFilter
        );
        setLogs(response.data.rows);
        setTotalPages(Math.ceil(response.data.count / 10));
        setLoading(false);
      } catch (err) {
        setError(err);
        setLoading(false);
      }
    };
    fetchLogs();
  }, [currentPage, selectedFilter]);

  return (
    <>
      <div className='min-h-screen  relative overflow-hidden  font-poppins'>
        <HeaderWithIcon title='Logs' />

        <div className='px-5 pt-4'>
          <div className='flex  gap-2.5'>
            <div className='w-1/3 max-xs:w-1/2'>
              {/* <Calendar></Calendar> */}
            </div>

            <div className='w-2/3 max-xs:w-1/2'>
              <label htmlFor='game' className='text-xs font-medium '>
                Filter
              </label>
              <div className='relative w-full'>
                <button
                  id='dropdownButton'
                  className='w-full p-2.5 text-xs font-normal text-gray-700 bg-white border rounded-md shadow-sm flex justify-between items-center '
                  onClick={() => setDropdownOpen(!dropdownOpen)}
                >
                  <span>All</span>
                  <span className='text-gray-500'>
                    {dropdownOpen ? (
                      <ChevronUp className='h-4 w-4' /> // ChevronUp icon for open state
                    ) : (
                      <ChevronDown className='h-4 w-4' /> // ChevronDown icon for closed state
                    )}
                  </span>
                </button>
                {dropdownOpen && (
                  <ul className='absolute left-0 z-10 w-full mt-1 bg-white border rounded-md shadow-md'>
                    {logFilter.map((filter, index) => (
                      <li
                        key={index}
                        onClick={() => {
                          setSelectedFilter(filter);
                          setDropdownOpen(false);
                        }}
                        className={`p-2.5 text-xs text-black hover:bg-[#E1E7EF] cursor-pointer ${
                          selectedFilter === filter ? 'bg-[#E1E7EF]' : ''
                        }`}
                      >
                        {filter}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className='px-5 pt-4'>
          <div
            className='divide-y divide-gray-200
           overflow-y-auto hide-scrollbar'
            style={{ height: 'calc(100vh - 150px)' }}
          >
            {logs &&
              logs?.map((result, index) => (
                <LogCard
                  key={index}
                  action={result.action}
                  type={result.type}
                  amount={{
                    price: result.value,
                    color:
                      result.action === 'DEDUCTED'
                        ? 'red-500'
                        : 'text-[#114C29]',
                  }}
                  date={result.createdAt}
                  reference={result.otherData?.loadRequestId}
                  transaction={result.transaction}
                  otherData={result.otherData}
                />
              ))}
          </div>

          <div className='flex justify-center py-4'>
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={setCurrentPage}
              showIcons
              className='pagination'
            />
          </div>
        </div>
      </div>
    </>
  );
}
